import React, { useState, useEffect, Suspense, lazy } from 'react';
import Header from './components/Header';
import LandingPage from './components/LandingPage';
import Footer from './components/Footer';
import type { LegalDocType } from './components/LegalModal';
const LegalModal = lazy(() => import('./components/LegalModal'));
const OmniOpsDemoTour = lazy(() => import('./components/OmniOpsDemoTour'));
const OnboardingPage = lazy(() => import('./components/OnboardingPage').then(module => ({ default: module.OnboardingPage })));

export type AppView = 'landing' | 'sandbox' | 'onboarding';

export default function App() {
  const [view, setView] = useState<AppView>('landing');
  const [legalType, setLegalType] = useState<LegalDocType | null>(null);
  const [isLegalOpen, setIsLegalOpen] = useState(false);

  // Smooth scroll to top when toggling views
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [view]);

  const handleOpenLegal = (type: LegalDocType) => {
    setLegalType(type);
    setIsLegalOpen(true);
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#fcfcfd]">
      
      {/* Global Navigation Header */}
      <Header activeView={view} onViewChange={setView} />

      {/* Main Core View Area */}
      <main className="flex-grow">
        {view === 'landing' ? (
          <div className="fade-in-up">
            <LandingPage onStartSimulator={() => setView('sandbox')} />
          </div>
        ) : (
          <Suspense fallback={<div className="flex items-center justify-center h-screen"><div className="w-8 h-8 border-4 border-sky-500 border-t-transparent rounded-full animate-spin"></div></div>}>
            {view === 'sandbox' ? (
              <OmniOpsDemoTour onClose={() => setView('landing')} />
            ) : (
              <div className="fade-in-up">
                <OnboardingPage />
              </div>
            )}
          </Suspense>
        )}
      </main>

      {/* Corporate SLA and Product Footer */}
      {view !== 'sandbox' && (
        <Footer activeView={view} onViewChange={setView} onOpenLegal={handleOpenLegal} />
      )}

      {/* Legal Documents Modal overlay */}
      <LegalModal 
        isOpen={isLegalOpen} 
        docType={legalType} 
        onClose={() => setIsLegalOpen(false)} 
      />
    </div>
  );
}
